export const publications = [
  {
    image: require("../../images/articles/economic_times.png"),
    title: "How an IIT Kanpur alumnus is using real-time AI systems to fix India's vehicle repair ecosystem",
    description: "The Economic Times is a nationally recognized mainstream business newspaper with one of the largest readerships among financial and technology publications in India, reaching hundreds of millions of visitors monthly.",
    link: "https://economictimes.indiatimes.com/news/india/how-an-iit-kanpur-alumnus-is-using-real-time-ai-systems-to-fix-indias-vehicle-repair-ecosystem/articleshow/126548310.cms"
  },
  {
    image: require("../../images/articles/financial_express.png"),
    title: "Why India's vehicle repair industry still struggles — and how AI is trying to fix it",
    description: "Financial Express, published by the Indian Express Group, is a nationally circulated business newspaper. The article identifies and quotes Lakshya Khurana on applying AI and real-time systems engineering to India's fragmented vehicle repair industry.",
    link: "https://www.financialexpress.com/business/sme/why-indias-vehicle-repair-industry-still-struggles-and-how-ai-is-trying-to-fix-it/3725841/"
  },
  {
    image: require("../../images/articles/vcpost.png"),
    title: "AI Meets Auto Repair: Ride N Repair Offers Fast, Transparent Service On-Demand",
    description: "Independent news source that tracks fast-moving developments where high-tech innovation and venture capital finance interest. They strive to empower readers by demystifying developments in technology, science, health, etc.",
    link: "https://www.vcpost.com/articles/128713/20241208/ai-meets-auto-repair-ride-n-repair-offers-fast-transparent-service-demand.htm"
  },
  {
    image: require("../../images/articles/dailyhunt.png"),
    title: "Revolutionizing Vehicle Servicing in India",
    description: "As India’s top news and local-language content platform, Dailyhunt boasts over 200 million app installations — providing an incredible platform to highlight our AI-driven innovations in automotive maintenance.",
    link: "https://m.dailyhunt.in/news/india/english/sangri+today-epaper-dhca0872bf801748bd9f43791084210e94/ai+meets+auto+repair+how+ride+n+repair+is+revolutionizing+vehicle+servicing+in+india-newsid-dhca0872bf801748bd9f43791084210e94_9e3c3b300bbc11f0afcbd3e67785a0c2?sm=Y"
  },
  {
    image: require("../../images/articles/business_standard.png"),
    title: "Startup Hustle to Industry Disruptor",
    description: "India’s leading business daily and the go-to source for serious business readership. Drawing over 15 million unique visitors each month—the highest among standalone business newspaper websites in India—Business Standard is the perfect platform to showcase how Ride N Repair is reshaping the future of vehicle maintenance.",
    link: "https://www.business-standard.com/content/press-releases-ani/from-startup-hustle-to-industry-disruptor-the-journey-of-ride-n-repair-s-founders-125032601107_1.html#goog_rewarded"
  },
  {
    image: require("../../images/articles/ians.png"),
    title: "AI Meets Auto Repair",
    description: "As one of India’s leading news agencies, IANS highlighted our mission to revolutionize vehicle maintenance through AI-driven technology and customer-centric innovation.",
    link: "https://ians.in/vmpl/ai-meets-auto-repair-how-ride-n-repair-is-revolutionizing-vehicle-servicing-in-india"
  },
  {
    image: require("../../images/articles/tribune_india.png"),
    title: "Journey of Ride N Repair Founders",
    description: "The largest-selling English daily in North India, known for publishing unbiased and in-depth news.",
    link: "https://www.tribuneindia.com/news/business/from-startup-hustle-to-industry-disruptor-the-journey-of-ride-n-repairs-founders/"
  },
  {
    image: require("../../images/articles/ani.png"),
    title: "ANI",
    description: "",
    link: "https://www.aninews.in/news/business/from-startup-hustle-to-industry-disruptor-the-journey-of-ride-n-repairs-founders20250326181733/"
  },
  {
    image: require("../../images/articles/theprint.png"),
    title: "ThePrint",
    description: "",
    link: "https://theprint.in/ani-press-releases/from-startup-hustle-to-industry-disruptor-the-journey-of-ride-n-repairs-founders/2566080/"
  },
  {
    image: require("../../images/articles/ceo_magazine_india.png"),
    title: "The CEO Magazine - India",
    description: "",
    link: "https://www.theceo.in/press-release/ai-meets-auto-repair-how-ride-n-repair-is-revolutionizing-vehicle-servicing-in-india"
  },
  {
    image: require("../../images/articles/lokmat_times.png"),
    title: "Lokmat Times",
    description: "",
    link: "https://www.lokmattimes.com/business/from-startup-hustle-to-industry-disruptor-the-journey-of-ride-n-repairs-founders/"
  },
  {
    image: require("../../images/articles/new_york_despatch.png"),
    title: "New York Despatch",
    description: "",
    link: "https://www.newyorkdespatch.com/news/from-startup-hustle-to-industry-disruptor-the-journey-of-ride-n-repairs-founders20250326181717/"
  }
];